export const GOAL_CARD_TEST_IDS = {
  CARD: 'goal-card',
  GOAL_EVENT: 'goal-event',
  GOAL_CUSTOM_EVENT_ICON: 'goal-custom-event-icon',
  OVERFLOW: 'goal-card-overflow-menu',
  CARD_LOADING: 'goal-card-loading',
};

export const GRAPH_MOCKS = [
  {
    name: 'Positive Series',
    data: [
      [1744264800000, 45],
      [1744275600000, 47],
      [1744286400000, 49],
      [1744297200000, 48],
      [1744308000000, 52],
      [1744318800000, 55],
      [1744329600000, 58],
      [1744340400000, 56],
      [1744351200000, 59],
      [1744362000000, 62],
      [1744372800000, 65],
      [1744383600000, 68],
      [1744394400000, 66],
      [1744405200000, 69],
      [1744416000000, 72],
      [1744426800000, 70],
      [1744437600000, 73],
      [1744448400000, 76],
      [1744459200000, 74],
      [1744470000000, 77],
      [1744480800000, 80],
      [1744491600000, 78],
      [1744502400000, 81],
      [1744513200000, 84],
      [1744524000000, 82],
      [1744534800000, 85],
      [1744545600000, 88],
      [1744556400000, 86],
      [1744567200000, 89],
      [1744578000000, 92],
      [1744588800000, 90],
      [1744599600000, 93],
      [1744610400000, 96],
      [1744621200000, 94],
      [1744632000000, 97],
      [1744642800000, 95],
      [1744653600000, 98],
      [1744664400000, 96],
      [1744675200000, 99],
      [1744686000000, 97],
      [1744696800000, 100],
      [1744707600000, 98],
      [1744718400000, 101],
      [1744729200000, 99],
      [1744740000000, 102],
      [1744750800000, 100],
      [1744761600000, 103],
      [1744772400000, 101],
      [1744783200000, 104],
      [1744794000000, 102],
      [1744804800000, 105],
      [1744815600000, 103],
      [1744826400000, 106],
      [1744837200000, 104],
      [1744848000000, 107],
      [1744858800000, 105],
      [1744869600000, 108],
      [1744880400000, 106],
      [1744891200000, 109],
      [1744902000000, 107],
      [1744912800000, 110],
      [1744923600000, 108],
      [1744934400000, 111],
      [1744945200000, 109],
      [1744956000000, 112],
    ],
  },
  {
    name: 'Negative Series',
    data: [
      [1744264800000, 112],
      [1744275600000, 110],
      [1744286400000, 108],
      [1744297200000, 109],
      [1744308000000, 105],
      [1744318800000, 102],
      [1744329600000, 99],
      [1744340400000, 101],
      [1744351200000, 98],
      [1744362000000, 95],
      [1744372800000, 92],
      [1744383600000, 89],
      [1744394400000, 91],
      [1744405200000, 88],
      [1744416000000, 85],
      [1744426800000, 87],
      [1744437600000, 84],
      [1744448400000, 81],
      [1744459200000, 83],
      [1744470000000, 80],
      [1744480800000, 77],
      [1744491600000, 79],
      [1744502400000, 76],
      [1744513200000, 73],
      [1744524000000, 75],
      [1744534800000, 72],
      [1744545600000, 69],
      [1744556400000, 71],
      [1744567200000, 68],
      [1744578000000, 65],
      [1744588800000, 67],
      [1744599600000, 64],
      [1744610400000, 61],
      [1744621200000, 63],
      [1744632000000, 60],
      [1744642800000, 62],
      [1744653600000, 59],
      [1744664400000, 61],
      [1744675200000, 58],
      [1744686000000, 60],
      [1744696800000, 57],
      [1744707600000, 59],
      [1744718400000, 56],
      [1744729200000, 58],
      [1744740000000, 55],
      [1744750800000, 57],
      [1744761600000, 54],
      [1744772400000, 56],
      [1744783200000, 53],
      [1744794000000, 55],
      [1744804800000, 52],
      [1744815600000, 54],
      [1744826400000, 51],
      [1744837200000, 53],
      [1744848000000, 50],
      [1744858800000, 52],
      [1744869600000, 49],
      [1744880400000, 51],
      [1744891200000, 48],
      [1744902000000, 50],
      [1744912800000, 47],
      [1744923600000, 49],
      [1744934400000, 46],
      [1744945200000, 48],
      [1744956000000, 45],
    ],
  },
];
